<!-- src/components-globalwork/metrics/pie_chart.vue -->
<template>
  <div class="pie-chart">
    <vx-card title="Status Procesos Finalizados">
      <!-- Total: {{ totalCount }} procesos -->

      <!-- =======================
           LEGACY FILTER (NO BORRAR)
           Comentado: ahora usa filtros globales de Graphics.vue
           ======================= -->
      <!--
      <form class="form-graphic">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full">
            Fecha de inicio:
            <datepicker
              :language="languages[language]"
              v-validate="'required'"
              class="pickadate-limits"
              name="dateStart"
              v-model="form.dateStart"
            />
            <span class="text-danger text-sm" v-show="errors.has('dateStart')">Requerido</span>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            Fecha final:
            <datepicker
              :language="languages[language]"
              v-validate="'required'"
              class="pickadate-limits"
              name="dateEnd"
              v-model="form.dateEnd"
            />
            <span class="text-danger text-sm" v-show="errors.has('dateEnd')">Requerido</span>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            Ciudades:
            <v-select v-model="form.city_id" :options="cities" name="project.city_id" />
            <span class="text-danger text-sm" v-show="errors.has('city')">Requerido</span>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <br />
            <vs-button type="filled" @click.prevent="submitForm" class="block">Consultar</vs-button>
          </div>
        </div>
        <br />
      </form>

      <br />
      -->

      <!-- LOADING -->
      <div v-if="uiState === 'loading'" class="gw-empty-state" style="height:350px;">
        <div class="gw-spinner" aria-label="Cargando"></div>
        <div class="gw-empty-title">Cargando información…</div>
        <div class="gw-empty-subtitle">Un momento por favor</div>
      </div>

      <!-- READY (CHART) -->
      <vue-apex-charts
        v-else-if="uiState === 'ready'"
        type="pie"
        height="350"
        :options="pieChart.chartOptions"
        :series="pieChart.series"
      />

      <!-- EMPTY / ERROR -->
      <div v-else class="gw-empty-state" style="height:350px;">
        <img class="gw-empty-img" :src="emptyStateImage" :alt="emptyStateAlt" />
        <div class="gw-empty-title">{{ emptyStateTitle }}</div>
        <div class="gw-empty-subtitle">{{ emptyStateSubtitle }}</div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { publicAssetUrl } from '@/utils/publicAssets'
import { eventBus } from "./../../main";
import VueApexCharts from "vue-apexcharts";
import api from "../../mixins/api";
import { mapGetters } from "vuex";

export default {
  props: ["startDate", "endDate", "cityId"],
  mixins: [api],

  data() {
    return {
      // UI states: 'loading' | 'ready' | 'empty' | 'error'
      uiState: "loading",
      consultHandler: null,
      requestKey: null,

      IMG_EMPTY:
        publicAssetUrl('Assets/illustrations/no_data_found.png'),
      IMG_ERROR:
        publicAssetUrl('Assets/illustrations/error.png'),

      totalCount: 0,

      pieChart: {
        series: [0, 0, 0],
        chartOptions: {
          labels: ["Confiables", "No confiables", "Confiables con observaciones"],
          colors: ["#28C76F", "#EA5455", "#FF9F43"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: { width: 200 },
                legend: { position: "bottom" },
              },
            },
          ],
        },
      },

      // ========= LEGACY (no borrar) =========
      // Dejo estas partes por si luego quieren reactivar el filtro interno
      // (pero el template está comentado)
      form: { dateStart: null, dateEnd: null, city_id: null },
      cities: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),

    emptyStateImage() {
      return this.uiState === "error" ? this.IMG_ERROR : this.IMG_EMPTY;
    },
    emptyStateAlt() {
      return this.uiState === "error"
        ? "Se produjo un error con la consulta"
        : "No se encontraron resultados";
    },
    emptyStateTitle() {
      return this.uiState === "error"
        ? "Se produjo un error con la consulta"
        : "Sin datos para el filtro seleccionado";
    },
    emptyStateSubtitle() {
      return this.uiState === "error"
        ? "Inténtalo de nuevo o ajusta los filtros."
        : "Prueba con otro rango de fechas o ciudad.";
    },
  },

  methods: {
    buildPathFromProps() {
      const user_id = this.userInfo.user.id;

      let parameters = `?start_date=${this.startDate}&end_date=${this.endDate}&current_user=${user_id}`;

      if (this.cityId != null) {
        parameters += `&city_id=${this.cityId}`;
      }

      return "/api/v1/reports/clients_pie_chart" + parameters;
    },

    setLoading(key) {
      this.requestKey = key;
      this.uiState = "loading";
      this.pieChart.series = [0, 0, 0];
      this.totalCount = 0;
    },

    setEmpty() {
      this.uiState = "empty";
      this.pieChart.series = [0, 0, 0];
      this.totalCount = 0;
    },

    setError() {
      this.uiState = "error";
      this.pieChart.series = [0, 0, 0];
      this.totalCount = 0;
    },

    setReady(series, totalCount) {
      this.pieChart.series = series;
      this.totalCount = totalCount || 0;
      this.uiState = "ready";
    },

    hasAnyValue(series) {
      if (!Array.isArray(series)) return false;
      for (let i = 0; i < series.length; i++) {
        let v = series[i];
        if (typeof v === "string") v = parseFloat(v);
        if (typeof v === "number" && !isNaN(v) && v > 0) return true;
      }
      return false;
    },

    async initializeData(origin) {
      if (!origin) origin = "unknown";

      // Si no hay fechas aún, no consulto
      if (!this.startDate || !this.endDate) {
        this.setEmpty();
        return;
      }

      const key = `${this.startDate}|${this.endDate}|${this.cityId || ""}`;
      this.setLoading(key);

      try {
        const path = this.buildPathFromProps();
        const response = await this.requestGetWithoutContent(this.url() + path, {});

        // race condition guard
        if (this.requestKey !== key) return;

        if (!response || !response.data || response.data.success !== true) {
          this.setError();
          return;
        }

        const series = Array.isArray(response.data.series)
          ? response.data.series
          : [0, 0, 0];

        const totalCount = response.data.total_count;

        if (!this.hasAnyValue(series)) {
          this.setEmpty();
        } else {
          this.setReady(series, totalCount);
        }
      } catch (e) {
        if (this.requestKey !== key) return;
        console.warn("[pie_chart] initializeData exception:", e);
        this.setError();
      }
    },
  },

  mounted() {
    this.initializeData("mounted");

    this.consultHandler = () => this.initializeData("eventBus:consultData");
    eventBus.$on("consultData", this.consultHandler);
  },

  beforeDestroy() {
    if (this.consultHandler) eventBus.$off("consultData", this.consultHandler);
  },

  components: {
    "vue-apex-charts": VueApexCharts,
  },
};
</script>

<style scoped>
.gw-empty-state{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  gap: 10px;
  text-align:center;
  padding: 16px;
}

.gw-empty-img{
  max-width: 260px;
  width: 100%;
  height: auto;
}

.gw-empty-title{
  font-weight: 600;
  font-size: 14px;
  color: #4b4b4b;
}

.gw-empty-subtitle{
  font-size: 12px;
  color: #7a7a7a;
}

.gw-spinner{
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid rgba(95,0,145,0.18);
  border-top-color: rgba(95,0,145,0.9);
  animation: gwspin 0.9s linear infinite;
}

@keyframes gwspin{
  to { transform: rotate(360deg); }
}
</style>
